import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
@Component({
  selector: 'app-scrolling-top-banner',
  templateUrl: './scrolling-top-banner.component.html',
  styleUrls: ['./scrolling-top-banner.component.scss'],
})
export class ScrollingTopBanner implements AfterViewInit, OnDestroy {
  @Input() bannerText: string[] = [];
  @Input() bgColor: string = '#4F4FFF';
  @Input() onClick?: () => void;
  @Input() onClose?: () => void;

  textCopyCount = 2;

  @ViewChild('trackRef') trackRef!: ElementRef<HTMLDivElement>;
  @ViewChild('lineRef') lineRef!: ElementRef<HTMLDivElement>;
  private ro: ResizeObserver | null = null;
  private timeoutId: number | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  handleClose(evt: MouseEvent) {
    evt.preventDefault();
    evt.stopPropagation();
    this.onClose?.();
  }

  handleClick() {
    this.onClick?.();
  }

  ngAfterViewInit(): void {
    this.updateBanner();
    this.timeoutId = window.setTimeout(() => this.updateBanner(), 100);

    const el = this.trackRef?.nativeElement;
    if (el) {
      this.ro = new ResizeObserver(() => this.updateBanner());
      this.ro.observe(el);
    }
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
    this.ro = null;
    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private getCopyCount(lineWidth: number, minCopies = 2): number {
    if (lineWidth <= 0) return minCopies;
    return Math.max(
      Math.ceil(((window.innerWidth + 100) / lineWidth) * 2),
      minCopies
    );
  }

  private getDuration(
    trackWidth: number,
    copyCount: number,
    pxPerSec: number
  ): number {
    const distance = trackWidth / copyCount;
    return distance / pxPerSec;
  }

  private updateBanner(): void {
    const el = this.trackRef?.nativeElement;
    const line = this.lineRef?.nativeElement;
    if (!el || !line) return;

    const lineWidth = line.scrollWidth;
    const copyCount = this.getCopyCount(lineWidth);
    const PX_PER_SEC = 30;
    const duration = this.getDuration(el.scrollWidth, copyCount, PX_PER_SEC);

    el.style.setProperty('--marquee-duration', `${duration}s`);
    el.style.setProperty('--translate-percent', `-${100 / copyCount}%`);
    this.textCopyCount = copyCount;
    this.cdr.detectChanges();
  }

  getCopiesArray(): number[] {
    return Array.from({ length: this.textCopyCount - 1 }, (_, i) => i);
  }
}
